import React from 'react';

type LogoProps = {
  className?: string;
  title?: string;
};

/** Full DEEPECHO wordmark SVG (uses currentColor). */
export function DeepechoWordmark({
  className = 'h-5 w-auto',
  title = 'Deep Echo',
}: LogoProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 261 35"
      fill="currentColor"
      className={className}
      role="img"
      aria-label={title}
    >
      <title>{title}</title>
      <path d="M6.26,5.69h8.19c2.48,0,4.65,0.47,6.53,1.42c1.88,0.94,3.33,2.29,4.34,4.04c1.01,1.75,1.52,3.79,1.52,6.1c0,2.31-0.51,4.34-1.52,6.09c-1.01,1.75-2.46,3.1-4.34,4.05c-1.88,0.95-4.05,1.42-6.53,1.42H6.26V5.69zM0,0.38v33.73h14.74c3.6,0,6.8-0.7,9.59-2.09c2.8-1.4,4.96-3.38,6.51-5.93c1.54-2.55,2.31-5.5,2.31-8.84s-0.77-6.29-2.31-8.84c-1.55-2.56-3.71-4.53-6.51-5.93C21.54,1.08,18.34,0.38,14.74,0.38H0z" />
      <polygon points="35.944,0.385 35.944,34.113 61.239,34.113 61.239,28.861 42.208,28.861 42.208,19.562 58.492,19.562 58.492,14.406 42.208,14.406 42.208,5.636 60.564,5.636 60.564,0.385" />
      <polygon points="64.371,0.385 64.371,34.113 89.666,34.113 89.666,28.861 70.634,28.861 70.634,19.562 86.92,19.562 86.92,14.406 70.634,14.406 70.634,5.636 88.992,5.636 88.992,0.385" />
      <path d="M99.06,5.69h7.33c2.73,0,4.8,0.57,6.21,1.73c1.41,1.16,2.12,2.81,2.12,4.96s-0.71,3.81-2.12,4.96c-1.41,1.16-3.49,1.74-6.21,1.74h-7.33V5.69zM92.8,0.38v33.73h6.26v-9.73h7.61c2.93,0,5.47-0.48,7.64-1.45c2.17-0.96,3.83-2.35,4.99-4.16c1.15-1.82,1.73-3.95,1.73-6.39c0-2.47-0.58-4.61-1.73-6.41s-2.82-3.18-4.99-4.14c-2.17-0.96-4.71-1.45-7.64-1.45H92.8z" />
      <polygon points="133.56,0.385 133.56,34.113 158.036,34.113 158.036,29.921 138.378,29.921 138.378,19.031 155.29,19.031 155.29,14.936 138.378,14.936 138.378,4.577 157.362,4.577 157.362,0.385" />
      <path d="M167.82,2.24c-2.73,1.49-4.87,3.55-6.41,6.17c-1.54,2.62-2.31,5.56-2.31,8.84c0,3.28,0.77,6.22,2.31,8.84c1.54,2.62,3.67,4.68,6.38,6.17c2.72,1.49,5.76,2.24,9.13,2.24c2.64,0,5.05-0.45,7.26-1.35c2.19-0.9,4.07-2.22,5.61-3.95l-3.13-3.04c-2.57,2.7-5.74,4.05-9.5,4.05c-2.5,0-4.77-0.56-6.79-1.69c-2.02-1.12-3.6-2.67-4.75-4.65c-1.14-1.97-1.7-4.18-1.7-6.62s0.56-4.65,1.7-6.63c1.15-1.97,2.73-3.52,4.75-4.64c2.02-1.13,4.29-1.69,6.79-1.69c3.79,0,6.96,1.33,9.5,4l3.13-3.04c-1.54-1.73-3.41-3.04-5.59-3.92c-2.19-0.89-4.6-1.33-7.23-1.33c-3.37,0-6.42,0.75-9.15,2.24" />
      <polygon points="217.01,0.385 217.01,14.888 197.641,14.888 197.641,0.385 192.823,0.385 192.823,34.113 197.641,34.113 197.641,19.08 217.01,19.08 217.01,34.113 221.83,34.113 221.83,0.385" />
      <path d="M234.12,2.24c-2.73,1.49-4.88,3.56-6.44,6.19c-1.56,2.64-2.33,5.58-2.33,8.82s0.77,6.18,2.33,8.82c1.56,2.63,3.7,4.69,6.44,6.19s5.79,2.24,9.2,2.24c3.37,0,6.42-0.75,9.15-2.24c1.28-0.7,2.42-1.52,3.43-2.47l-4.21-2.43c-0.53,0.43-1.09,0.82-1.7,1.16c-1.97,1.13-4.2,1.69-6.67,1.69c-2.48,0-4.72-0.56-6.72-1.69c-2.01-1.12-3.58-2.67-4.73-4.65c-1.14-1.97-1.71-4.18-1.71-6.62s0.57-4.65,1.71-6.63c1.14-1.97,2.72-3.52,4.73-4.65c2-1.12,4.24-1.68,6.72-1.68c2.47,0,4.7,0.56,6.67,1.68c0.56,0.32,1.08,0.68,1.57,1.06l4.22-2.44c-0.98-0.89-2.08-1.68-3.31-2.35c-2.73-1.49-5.78-2.24-9.15-2.24c-3.41,0-6.48,0.75-9.2,2.24" />
      <path d="M260.99,17.17c0.05,1.2-0.1,2.38-0.37,3.55c-0.4,1.71-1.05,3.32-1.98,4.81c-0.65,1.05-1.4,2.01-2.27,2.88c-0.36,0.35-0.81,0.24-0.97-0.24c-0.08-0.22,0.02-0.39,0.16-0.53c0.76-0.79,1.45-1.64,2.04-2.56c0.58-0.93,1.05-1.91,1.42-2.94c0.35-0.95,0.6-1.94,0.72-2.94c0.11-0.89,0.18-1.79,0.12-2.7c-0.05-0.74-0.11-1.47-0.25-2.2c-0.15-0.75-0.35-1.49-0.61-2.22c-0.41-1.11-0.94-2.17-1.6-3.16c-0.53-0.8-1.15-1.53-1.82-2.22c-0.17-0.19-0.28-0.38-0.15-0.65c0.17-0.37,0.6-0.47,0.9-0.19c0.69,0.67,1.29,1.42,1.84,2.2c0.6,0.86,1.11,1.77,1.52,2.72c0.35,0.8,0.64,1.63,0.85,2.48c0.2,0.78,0.31,1.57,0.41,2.37c0.06,0.51,0.02,1.03,0.04,1.54" />
      <path d="M257.48,17.08c-0.07,3.39-1.2,6.31-3.54,8.73c-0.05,0.05-0.1,0.1-0.16,0.15c-0.25,0.2-0.53,0.18-0.76-0.05c-0.18-0.18-0.19-0.53-0.01-0.74c0.29-0.33,0.6-0.65,0.87-0.99c0.85-1.08,1.48-2.26,1.9-3.57c0.43-1.34,0.63-2.71,0.53-4.11c-0.07-1.07-0.28-2.13-0.65-3.15c-0.57-1.58-1.43-2.95-2.6-4.15c-0.23-0.23-0.24-0.6-0.04-0.8c0.23-0.25,0.57-0.25,0.84,0.02c0.79,0.78,1.45,1.67,2,2.64c0.51,0.89,0.9,1.84,1.17,2.83c0.29,1.06,0.42,2.15,0.45,3.19" />
      <path d="M252.77,17.16c-0.01-2.1-0.75-3.89-2.19-5.41c-0.33-0.35-0.3-0.76,0.09-0.97c0.22-0.11,0.44-0.08,0.66,0.13c0.79,0.81,1.42,1.72,1.87,2.76c0.36,0.84,0.58,1.73,0.67,2.63c0.07,0.64,0.06,1.27-0.03,1.91c-0.08,0.51-0.17,1.01-0.31,1.5c-0.32,1.11-0.86,2.1-1.58,2.99c-0.18,0.22-0.37,0.44-0.58,0.65c-0.26,0.28-0.59,0.3-0.83,0.08c-0.26-0.25-0.27-0.57,0.02-0.86c0.74-0.75,1.3-1.62,1.69-2.6c0.19-0.46,0.3-0.94,0.4-1.43c0.1-0.45,0.11-0.92,0.12-1.38" />
    </svg>
  );
}

/** Compact mark SVG for collapsed menu (uses currentColor). */
export function DeepechoMark({
  className = 'h-7 w-auto',
  title = 'Deep Echo',
}: LogoProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 265 260"
      fill="none"
      className={className}
      role="img"
      aria-label={title}
    >
      <title>{title}</title>
      <path
        d="M 216.656,218.406 A 127.500,127.500 0 1 1 216.656,38.094 L 192.968,61.782 A 94.000,94.000 0 1 0 192.968,194.718 Z"
        fill="currentColor"
      />
      <path
        d="M 192.430,82.938 A 80.000,80.000 0 0 1 193.971,171.234"
        fill="none"
        stroke="currentColor"
        strokeWidth="8"
        strokeLinecap="round"
      />
      <path
        d="M 210.794,63.569 A 106.250,106.250 0 0 1 213.535,189.192"
        fill="none"
        stroke="currentColor"
        strokeWidth="8"
        strokeLinecap="round"
      />
      <path
        d="M 229.472,44.865 A 132.500,132.500 0 0 1 233.011,207.064"
        fill="none"
        stroke="currentColor"
        strokeWidth="8"
        strokeLinecap="round"
      />
    </svg>
  );
}
